/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormInput,
  FormLabel,
  FormTextarea,
} from 'src/components/Common/FormComponent';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import i18next from 'i18next';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';

const AdvancedOptionModal = (props: {
  replacementTextDesc: string;
  isVisible: boolean;
  onClose: () => void;
  availableTokenShow: boolean;
  replaceFileNameShow: boolean;
  config: {
    replaceFileName?: string;
    replaceText: string;
    replaceTextDefault: string;
  };
  saveConfig: (config: {
    replaceFileName: string;
    replaceText: string;
  }) => void;
}) => {
  const {
    replacementTextDesc,
    isVisible,
    onClose,
    availableTokenShow,
    replaceFileNameShow,
    config: { replaceFileName = '', replaceText, replaceTextDefault },
    saveConfig,
  } = props;
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const [fileName, setFileName] = React.useState(replaceFileName);
  const [text, setText] = React.useState(replaceText);
  const onReset = React.useCallback(() => {
    setText(replaceTextDefault);
  }, [replaceTextDefault]);
  const onSave = React.useCallback(() => {
    const config = {
      replaceFileName: fileName,
      replaceText: text,
    };
    saveConfig(config);
    onClose();
  }, [fileName, text]);
  useWhyDidYouUpdate('MalwareScanning AdvancedOptionModal', {
    ...props,
    text,
    fileName,
  });

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={isVisible}
      onClose={onClose}
      size="lg"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent backgroundColor={colorStyle.background.secondary}>
        <ModalHeader></ModalHeader>

        <ModalBody ml="24px" mt="16px" mb="16px">
          <Flex direction="column">
            <Flex mb="16px">
              <Text>{replacementTextDesc}</Text>
            </Flex>
            {replaceFileNameShow && (
              <Flex mb="16px">
                <FormLabel label={t('policy.action.replaceAction.filename')} />
                <FormInput
                  placeholder={t('policy.action.replaceAction.filenameInput')}
                  value={fileName}
                  width="600px"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    console.log(e.target.value);
                    setFileName(e.target.value);
                  }}
                />
              </Flex>
            )}
            <Flex mb="16px">
              <FormLabel label={t('policy.action.replaceAction.text')} />
              <FormTextarea
                value={text}
                width="600px"
                onChange={(e) => {
                  setText(e.target.value);
                }}
              />
            </Flex>
            <Flex>
              <FormLabel label="" />
              <Button onClick={() => onReset()}>
                {t('common.label.reset')}
              </Button>
              {availableTokenShow && (
                <Link
                  width="100%"
                  href={getCasOLHLink(
                    CAS_DOC_LINK.policy.atp.tokenList,
                    i18next.language
                  )}
                  target="_blank"
                >
                  <Text
                    ml={12}
                    overflow="hidden"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    {t('policy.label.availableTokens')}
                  </Text>
                </Link>
              )}
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" minWidth="20x" onClick={onSave}>
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default React.memo(AdvancedOptionModal);
